const currencies = {
  sgd: "SGD",
};
export { currencies };
